import Component from 'classes/Component'
import GSAP from 'gsap'

export default class Navigation extends Component {
  constructor () {
    super({
      element: '.menu',
      elements: {
        body: document.documentElement,
        content: document.querySelector('.content'),
        header: document.querySelector('.header'),
        menu: '.menu_button',
        left: '.menu_left',
        right: '.menu_right',
        social: '.menu_social',
        list: '.menu_list_item',
        listsmall: '.menu_list_item_small',
        images: '.menu_images',
        copyright: '.menu_copyright',
        links: '.menu_list_item_link',
        reserve: '.reserve_button'
      }
    })

    this.elements.all = [
      this.elements.images,
      this.elements.copyright,
      this.elements.social,
      this.elements.listsmall,
      this.elements.list
    ]

    this.tl = GSAP.timeline()

    this.createMenuClick()
  }

  menuClicked = () => {
    this.tl.clear()

    this.tl.to(this.elements.content, {
      autoAlpha: 0,
      duration: 1.5,
      ease: 'expo.out'
    }).to(this.element, {
      autoAlpha: 1,
      duration: 1,
      ease: 'expo.out'
    }, '<').fromTo(this.elements.all, {
      autoAlpha: 0,
      y: '20px',
      scaleY: '1.03'
    }, {
      stagger: {
        axis: 'x',
        each: 0.05
      },
      autoAlpha: 1,
      duration: 1,
      rotation: 0.01,
      scaleY: '1',
      y: 0,
      ease: 'power2.out'
    }, '<').to(this.elements.reserve, {
      autoAlpha: 0
    }, '<')

    this.tl.restart()

    this.element.classList.add('menu_visible')
    this.element.classList.remove('menu_hidden')

    this.elements.body.classList.add('no_scroll')
    this.elements.body.classList.remove('scroll')

    this.elements.menu.classList.add('menu_button_close')

    this.elements.menu.removeEventListener('click', this.menuClicked)
    this.elements.menu.addEventListener('click', this.menuClose)

    this.elements.header.classList.add('nobg')
  }

  menuClose = () => {
    this.tl.clear()

    this.tl.fromTo(this.elements.all, {
      autoAlpha: 1,
      y: 0
    }, {
      autoAlpha: 0,
      stagger: {
        axis: 'x',
        each: 0.05
      },
      duration: 1,
      ease: 'power2.out',
      y: '20px'
    }).to(this.element, {
      autoAlpha: 0,
      duration: 2,
      ease: 'expo.out'
    }, '<').fromTo(this.elements.content, {
      autoAlpha: 0
    }, {
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out'
    }, '<').to(this.elements.reserve, {
      autoAlpha: 1
    }, '<')

    this.tl.restart()

    this.element.classList.add('menu_hidden')
    this.element.classList.remove('menu_visible')

    this.elements.body.classList.remove('no_scroll')
    this.elements.body.classList.add('scroll')

    this.elements.menu.classList.remove('menu_button_close')

    this.elements.menu.removeEventListener('click', this.menuClose)
    this.elements.menu.addEventListener('click', this.menuClicked)

    this.elements.header.classList.remove('nobg')
  }

  imagesChange = () => {
  }

  createImagesHover = () => {
    this.elements.list.addEventListener('mouseover', this.imagesChange)
  }

  createMenuClick = () => {
    this.elements.menu.addEventListener('click', this.menuClicked)
  }
}
